import React, {useEffect, useRef, useState} from "react";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import MinusCircleIcon from "assets/icons/MinusCircle";
import PlusCircleIcon from "assets/icons/PlusCircle";

const IconContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "24px",
  height: "24px",
}));

const IconBase = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  transition: "transform 0.3s ease, opacity 0.3s ease",
  color: theme.palette.black[100],
  opacity: 0.5
}));

const AccordionIcon = () => {
  const summaryRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const summaryElement = summaryRef.current?.closest('.MuiAccordionSummary-root');

    if (summaryElement) {
      const handleClassChange = () => {
        const isExpanded = summaryElement.classList.contains('Mui-expanded');
        setExpanded(isExpanded);
      };

      const observer = new MutationObserver(handleClassChange);
      observer.observe(summaryElement, { attributes: true, attributeFilter: ['class'] });

      handleClassChange();

      return () => observer.disconnect();
    }
  }, []);

  return (
    <IconContainer ref={summaryRef}>
      <IconBase
        sx={{
          visibility: expanded ? 'visible' : 'hidden',
          zIndex: expanded ? 2 : 0,
        }}
      >
        <MinusCircleIcon/>
      </IconBase>
      <IconBase
        sx={{
          visibility: expanded ? 'hidden' : 'visible',
          zIndex: expanded ? 0 : 2,
        }}
      >
        <PlusCircleIcon  />
      </IconBase>
    </IconContainer>
  );
};

export default AccordionIcon;
